module.exports = __webpack_public_path__ + "static/img/silhouette-1.ab4ac22.svg";